export default {"src":"/_next/static/media/export-outlined.cae29ef8.svg","height":28,"width":28};